import { go, map, reduce } from 'fxjs/es';
import { price } from './price.js';

export function baseCalcAll(calcF) {
  return function (a) {
    const list = Array.isArray(a) ? a : Array.prototype.slice.call(arguments);
    return !list.length ? 0 : go(list, map(price), reduce(calcF), price);
  };
}
